<div class="container">
  @if (isEdit) {
  <mat-toolbar>
    <button mat-icon-button matTooltip="Atrás" aria-label="Atrás" (click)="onBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    @if (hasParticipated && isOwner) {
    &nbsp;&nbsp;&nbsp;
    <button mat-icon-button matTooltip="Borrar" aria-label="Borrar" (click)="onDelete()">
      <mat-icon>
        <span class="material-symbols-outlined">
          delete
        </span>
      </mat-icon>
    </button>
    <button mat-icon-button matTooltip="Editar" aria-label="Editar" (click)="onClickEdit()">
      <mat-icon>
        <span class="material-symbols-outlined">
          edit
        </span>
      </mat-icon>
    </button>
    <button mat-icon-button matTooltip="Reasignar" aria-label="Reasignar" (click)="onReasign()">
      <mat-icon>
        group
      </mat-icon>
    </button>
    @if(permisos.tarea.includes(documento?.estadoTarea) && documento.subEstadoTarea < 1){ <button mat-icon-button
      matTooltip="Nueva tarea" aria-label="Nueva tarea" (click)="onNewtask()">
      <mat-icon>
        <span class="material-symbols-outlined">
          note_add
        </span>
      </mat-icon>
      </button>
      }
      @if(documento?.de.length > 1 && documento?.de.at(0).idTipoSolicitante == 1){
      <button mat-icon-button matTooltip="Firma conjunta" aria-label="Nueva tarea" (click)="onFirmaConjunta()">
        <mat-icon>
          <span class="material-symbols-outlined">
            diversity_3
          </span>
        </mat-icon>
      </button>
      }
      @if(permisos.enviar.includes(documento?.estadoTarea) && reply){
      &nbsp;
      <button [disabled]="fetchingDocumentClose" class="send-close-option" mat-flat-button color="normal"
        [matMenuTriggerFor]="menu">
        <div class="btn-login-content">
          @if (fetchingDocumentClose) {
          <mat-spinner diameter="20" color="warn"></mat-spinner>
          }@else{
          <p>Enviar</p>
          }
        </div>
      </button>
      <mat-menu #menu="matMenu">
        <button routerLink="/finalizar/{{idTarea}}/{{idAnexo}}" class="send-close-option" mat-menu-item>Firmado
          electr&oacute;nicamente</button>
        <button (click)="onSendDocument()" class="send-close-option" mat-menu-item>Sin firmar</button>
      </mat-menu>
      }@else{
      <span matTooltip="Se habilitar&aacute; cuando no tenga tareas pendientes">
        <button mat-flat-button color="normal" disabled>Enviar</button>
      </span>
      }
      }
  </mat-toolbar>
  }@else {
  <mat-toolbar>
    <button mat-icon-button matTooltip="Atrás" aria-label="Atrás" (click)="onBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    &nbsp;&nbsp;&nbsp;
    @if (hasParticipated && isOwner) {
    @if(permisos.responder.includes(documento?.estadoTarea) && documento.tipoAtencion != 1 && documento.tipoAtencion !=
    2){
    <button mat-icon-button matTooltip="Responder" aria-label="Responder" (click)="onReply()" [disabled]="!this.reply">
      <mat-icon>
        <span class="material-symbols-outlined">
          reply_all
        </span>
      </mat-icon>
    </button>
    <button mat-icon-button matTooltip="Direccionar" aria-label="Direccionar" (click)="onToDirect()"
      [disabled]="!this.reply">
      <mat-icon>
        send
      </mat-icon>
    </button>
    }
    @if(permisos.reasignar.includes(documento?.estadoTarea) && documento.tipoAtencion != 1 && documento.tipoAtencion !=
    2){
    <button mat-icon-button matTooltip="Reasignar" aria-label="Reasignar" (click)="onReasign()"
      [disabled]="!this.reply">
      <mat-icon>
        group
      </mat-icon>
    </button>
    }
    @if(permisos.archivar.includes(documento?.estadoTarea) && documento.tipoAtencion != 2){
    <button mat-icon-button matTooltip="Archivar" aria-label="Archivar" (click)="archivar()" [disabled]="!this.reply">
      <mat-icon>
        save
      </mat-icon>
    </button>
    }
    @if((permisos.comentar.includes(documento?.estadoTarea) && documento.tipoAtencion != 1 && documento.tipoAtencion !=
    2) || (tipoTarea === 2 &&
    documento.tipoAtencion == 2) ){
    <button mat-icon-button matTooltip="Comentar" aria-label="Comentar" (click)="onAddComment()">
      <mat-icon>
        comment
      </mat-icon>
    </button>
    }

    @if((permisos.alcance.includes(documento?.estadoTarea) && documento.tipoAtencion != 1 && documento.tipoAtencion !=
    2) || (tipoTarea === 2 &&
    documento.tipoAtencion == 2) ){
    <button mat-icon-button matTooltip="Recuperar" aria-label="Recuperar" (click)="onRecuperar()">
      <mat-icon>
        settings_backup_restore
      </mat-icon>
    </button>

    }

    @if(permisos.alcance.includes(documento?.estadoTarea) && documento.tipoAtencion === -1){
    <button mat-icon-button matTooltip="Alcance" aria-label="Alcance" (click)="onAlcanceDocumento()">
      <mat-icon>
        <span class="material-symbols-outlined">account_tree</span>
      </mat-icon>
    </button>
    }

    @if(permisos.tarea.includes(documento?.estadoTarea) && documento.tipoAtencion != 1 && documento.subEstadoTarea < 1){
      <button mat-icon-button matTooltip="Nueva tarea" aria-label="Nueva tarea" (click)="onNewtask()">
      <mat-icon>
        note_add
      </mat-icon>
      </button>
      }
      }
  </mat-toolbar>
  }

  @if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }  @else {
    @if(!dataFound){
      <app-no-result></app-no-result>
    } @else {
  <mat-tab-group style="height: 100%" [selectedIndex]="bandejaIndex" (selectedTabChange)="onTabChange($event)" [preserveContent]="true">
    <mat-tab label="Informaci&oacute;n">
      <ng-template mat-tab-label>
        <mat-icon class="material-symbols-outlined tab-icon">info</mat-icon>
        Informaci&oacute;n
      </ng-template>
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-4">
            <mat-card appearance="outlined">
              <mat-card-header>
                <div mat-card-avatar><mat-icon>numbers</mat-icon></div>
                <mat-card-title>N&uacute;mero</mat-card-title>
                <mat-card-subtitle>{{documento?.anio}}-{{documento?.numero}}</mat-card-subtitle>
              </mat-card-header>
            </mat-card>
          </div>
          <div class="col-12 col-md-8">
            <mat-card appearance="outlined">
              <mat-card-header>
                <div mat-card-avatar><mat-icon>lightbulb</mat-icon></div>
                <mat-card-title>Asunto</mat-card-title>
                <mat-card-subtitle style="text-align: justify;">{{documento?.asunto}}</mat-card-subtitle>
              </mat-card-header>
            </mat-card>
          </div>
          <div class="col-sm-12 col-md-6 col-xl-4">
            <mat-card appearance="outlined">
              <mat-card-header style="padding-right: 0;">
                <div mat-card-avatar><mat-icon> account_circle </mat-icon></div>
                <mat-card-title>De</mat-card-title>
                <mat-card-subtitle style="text-align: justify; padding-right: 0;">
                  @if(documento?.departamento.length > 0) {
                    <span>{{documento.departamento}}</span><br><br>
                  }
                  @if(documento?.de && documento.de.length > 0) {
                    {{documento.de[0].titulo||''}} {{documento.de[0].nombres}} {{documento.de[0].apellidos}}
                    @if(documento.de.length > 1) {
                      <button mat-icon-button 
                              [matMenuTriggerFor]="menuDe"
                              matTooltip="Ver todos ({{documento.de.length}})"
                              style="vertical-align: middle; margin-left: 4px;">
                        <mat-icon style="font-size: 20px;">more_horiz</mat-icon>
                      </button>
                      <mat-menu #menuDe="matMenu">
                        <div style="padding: 12px; max-width: 400px; max-height: 300px; overflow-y: auto;" (click)="$event.stopPropagation()">
                          @for (de of documento?.de; track de.id; let index = $index) {
                            <div style="padding: 8px 0; display: flex; align-items: center; gap: 8px;">
                              <mat-icon style="font-size: 20px;">person</mat-icon>
                              <span>{{de.titulo||''}} {{de.nombres}} {{de.apellidos}}</span>
                            </div>
                          }
                        </div>
                      </mat-menu>
                    }
                  }
                </mat-card-subtitle>
              </mat-card-header>
            </mat-card>
          </div>
          <div class="col-sm-12 col-md-6 col-xl-4">
            <mat-card appearance="outlined">
              <mat-card-header style="padding-right: 0;">
                <div mat-card-avatar><mat-icon> group </mat-icon></div>
                <mat-card-title>Para</mat-card-title>
                <mat-card-subtitle style="text-align: justify; padding-right: 0;">
                  @if(documento?.buzonesPara && documento.buzonesPara.length > 0) {
                    {{documento.buzonesPara[0].cargo ||''}}
                    @if(documento.buzonesPara.length > 1) {
                      <button mat-icon-button 
                              [matMenuTriggerFor]="menuDe"
                              matTooltip="Ver todos ({{documento.buzonesPara.length}})"
                              style="vertical-align: middle; margin-left: 4px;">
                        <mat-icon style="font-size: 20px;">more_horiz</mat-icon>
                      </button>
                      <mat-menu #menuDe="matMenu">
                        <div style="padding: 12px; max-width: 400px; max-height: 300px; overflow-y: auto;" (click)="$event.stopPropagation()">
                          @for (para of documento?.buzonesPara; track para.id; let index = $index) {
                            <div style="padding: 8px 0; display: flex; align-items: center; gap: 8px;">
                              <mat-icon style="font-size: 20px;">person</mat-icon>
                              <span>{{para.cargo||''}}</span>
                            </div>
                          }
                        </div>
                      </mat-menu>
                    }
                    @if(documento?.para) {
                      @if(documento.para.length <= 1) {
                        <br/><br/>
                      }
                      @if(documento.para.length > 1) {
                        <br/>
                      }
                    }
                  }
                  @if(documento?.para && documento.para.length > 0) {
                    {{documento.para[0].titulo||''}} {{documento.para[0].nombres}} {{documento.para[0].apellidos}}
                    @if(documento.para.length > 1) {
                      <button mat-icon-button 
                              [matMenuTriggerFor]="menuPara"
                              matTooltip="Ver todos ({{documento.para.length}})"
                              style="vertical-align: middle; margin-left: 4px;">
                        <mat-icon style="font-size: 20px;">more_horiz</mat-icon>
                      </button>
                      <mat-menu #menuPara="matMenu">
                        <div style="padding: 12px; max-width: 400px; max-height: 300px; overflow-y: auto;" (click)="$event.stopPropagation()">
                          @for (para of documento?.para; track para.id; let index = $index) {
                            <div style="padding: 8px 0; display: flex; align-items: center; gap: 8px;">
                              <mat-icon style="font-size: 20px;">person</mat-icon>
                              <span>{{para.titulo||''}} {{para.nombres}} {{para.apellidos}}</span>
                            </div>
                          }
                        </div>
                      </mat-menu>
                    }
                  }
                </mat-card-subtitle>
              </mat-card-header>
            </mat-card>
          </div>
          @if (documento?.cc && documento?.cc.length > 0) {
          <div class="col-sm-12 col-md-6 col-xl-4">
            <mat-card appearance="outlined">
              <mat-card-header style="padding-right: 0;">
                <div mat-card-avatar><mat-icon> groups </mat-icon></div>
                <mat-card-title>Copia:</mat-card-title>
                <mat-card-subtitle style="text-align: justify; padding-right: 0;">
                  @if(documento.cc.length > 0) {
                    {{documento.cc[0].titulo||''}} {{documento.cc[0].nombres}} {{documento.cc[0].apellidos}}
                    @if(documento.cc.length > 1) {
                      <button mat-icon-button 
                              [matMenuTriggerFor]="menuCc"
                              matTooltip="Ver todos ({{documento.cc.length}})"
                              style="vertical-align: middle; margin-left: 4px;">
                        <mat-icon style="font-size: 20px;">more_horiz</mat-icon>
                      </button>
                      <mat-menu #menuCc="matMenu">
                        <div style="padding: 12px; max-width: 400px; max-height: 300px; overflow-y: auto;" (click)="$event.stopPropagation()">
                          @for (copia of documento?.cc; track copia.id; let index = $index) {
                            <div style="padding: 8px 0; display: flex; align-items: center; gap: 8px;">
                              <mat-icon style="font-size: 20px;">person</mat-icon>
                              <span>{{copia.titulo||''}} {{copia.nombres}} {{copia.apellidos}}</span>
                            </div>
                          }
                        </div>
                      </mat-menu>
                    }
                  }
                </mat-card-subtitle>
              </mat-card-header>
            </mat-card>
          </div>
          }
          <div class="col-sm-12 col-md-6 col-xl-4">
            <mat-card appearance="outlined">
              <mat-card-header>
                <div mat-card-avatar><mat-icon> calendar_month </mat-icon></div>
                <mat-card-title>Fecha documento</mat-card-title>
                <mat-card-subtitle>{{documento?.fecha}}</mat-card-subtitle>
              </mat-card-header>
            </mat-card>
          </div>
          <div class="col-sm-12 col-md-6 col-xl-4">
            <mat-card appearance="outlined">
              <mat-card-header>
                <div mat-card-avatar><mat-icon>workspace_premium</mat-icon></div>
                <mat-card-title>No. Documento</mat-card-title>
                <mat-card-subtitle style="font-size: small;">{{documento?.numeroDocumento}}</mat-card-subtitle>
              </mat-card-header>
            </mat-card>
          </div>
          <div class="col-sm-12 col-md-6 col-xl-4">
            <mat-card appearance="outlined">
              <mat-card-header>
                <div mat-card-avatar><mat-icon>title</mat-icon></div>
                <mat-card-title>Tipo de documento</mat-card-title>
                <mat-card-subtitle>{{documento?.tipoDocumento?.descripcion}}</mat-card-subtitle>
              </mat-card-header>
            </mat-card>
          </div>
          <div class="col-sm-12 col-md-6 col-xl-4">
            <mat-card appearance="outlined">
              <mat-card-header>
                <div mat-card-avatar [ngClass]="documento?.categoria===3?'icon-urgente':''">
                  <mat-icon>priority_high</mat-icon>
                </div>
                <mat-card-title
                  [ngClass]="documento?.categoria===3?'titulo-urgente':''">Categor&iacute;a</mat-card-title>
                <mat-card-subtitle
                  [ngClass]="documento?.categoria===3||documento?.categoria===0?(documento?.categoria===0?'texto-warning':'texto-urgente'):''">{{documento?.categoria
                  |
                  categoria}}</mat-card-subtitle>
              </mat-card-header>
            </mat-card>
          </div>
          <div class="col-sm-12 col-md-6 col-xl-4">
            <mat-card appearance="outlined">
              <mat-card-header>
                <div mat-card-avatar><mat-icon>hourglass_bottom</mat-icon></div>
                <mat-card-title>Estado del documento</mat-card-title>
                <mat-card-subtitle>{{documento?.estadoTareaDescripcion}}</mat-card-subtitle>
              </mat-card-header>
            </mat-card>
          </div>
          <div class="col-sm-12 col-md-6 col-xl-4">
            <mat-card appearance="outlined">
              <mat-card-header>
                <div mat-card-avatar><mat-icon> category </mat-icon></div>
                <mat-card-title>Tipificaci&oacute;n</mat-card-title>
                <mat-card-subtitle>{{documento?.tipificacion | tipificacion}}</mat-card-subtitle>
              </mat-card-header>
            </mat-card>
          </div>
          <div class="col-sm-12 col-md-6 col-xl-4">
            <mat-card appearance="outlined">
              <mat-card-header>
                <div mat-card-avatar [ngClass]="documento?.externo===1?'icon-urgente':''">
                  <mat-icon>{{documento?.externo===1 ?'contact_page':'description'}}</mat-icon>
                </div>
                <mat-card-title [ngClass]="documento?.externo===1?'titulo-urgente':''">Documento</mat-card-title>
                <mat-card-subtitle [ngClass]="documento?.externo===1?'titulo-urgente':''">{{documento?.externo===1
                  ?'Ciudadano':'Interno'}}</mat-card-subtitle>
              </mat-card-header>
            </mat-card>
          </div>
        </div>
        <br>
        <div id="divPdf">
          <div class="row">
            <mat-toolbar class="pdf-tools">
              <span class="sgd-spacer"></span>
              <button mat-icon-button id="zoomOut" (click)="zoomOut()"><mat-icon>remove</mat-icon></button>
              <button mat-icon-button id="zoomIn" (click)="zoomIn()"><mat-icon>add</mat-icon></button>
              <button mat-icon-button id="presentationMode"><mat-icon>fullscreen</mat-icon></button>
              <span class="sgd-spacer"></span>
              <button mat-icon-button id="previous"><mat-icon>arrow_back</mat-icon></button>
              <mat-form-field id="txtPage">
                <input matInput type="number" id="pageNumber">
              </mat-form-field>
              <button mat-icon-button id="next"><mat-icon>arrow_forward</mat-icon></button>
              <span style="display: none;">
                <pdf-zoom-toolbar></pdf-zoom-toolbar>
              </span>
            </mat-toolbar>
          </div>
          <div style="min-height: 256px;">
            <ngx-extended-pdf-viewer [src]="filePdf" pageViewMode="multiple" [height]="'80vh'" [(zoom)]="zoomSetting"
              [sidebarVisible]="false" [zoomLevels]="zoomLevels" [showBorders]="true" [showUnverifiedSignatures]="true"
              [textLayer]="true" [showToolbar]="false" (pageRendered)="onRenderPage()"
              [ignoreKeys]="['CTRL+F']"></ngx-extended-pdf-viewer>
          </div>
        </div>
      </div>
    </mat-tab>    
    <mat-tab label="Diagrama">
      <ng-template mat-tab-label>
        <mat-icon class="material-symbols-outlined tab-icon">flowchart</mat-icon>
        Diagrama
      </ng-template>
      <app-interactive-org-chart [idTarea]="idTarea" (clickNode)="refreshAnexosRecorrido($event)"/>
    </mat-tab>
    <mat-tab label="Anexos">
      <ng-template mat-tab-label>
        @if (loadingAnexos){
        <mat-spinner mode="indeterminate" class="tap-icon" color="primary" diameter="20" ></mat-spinner>
        }@else{
        <mat-icon class="tab-icon" [style.color]="idTarea == idTareaAnexos || idTareaAnexos == 0 ? '' : 'gray'" >attach_file</mat-icon>
        }
        Anexos
      </ng-template>
      <app-anexos-full (successRefresh)="successRefreshHandler($event)" [anexos]="anexos" [idTarea]="idTarea"
        [isEdit]="isEdit" [hasParticipated]="hasParticipated" [isOwner]="isOwner" [estadoTarea]="estadoTarea"
        [tareas]="documentoTareas"></app-anexos-full>
    </mat-tab>
    <mat-tab label="Recorrido">
      <ng-template mat-tab-label>
        @if (loadingAnexos){
        <mat-spinner mode="indeterminate" class="tap-icon" color="primary" diameter="20" ></mat-spinner>
        }@else{
          <mat-icon class="material-symbols-outlined tab-icon" [style.color]="idTarea == idTareaAnexos || idTareaAnexos == 0 ? '' : 'gray'" >footprint</mat-icon>        
        }
        Recorrido
      </ng-template>
      <div class="full-anexos-container">
        <!-- Acciones -->
        <div class="anexos-container">
          <h4 class="anexos-title">Acciones</h4>
          @if(documentRouteAcciones.length > 0) {
            <div class="recorrido-list">
              @for (accion of documentRouteAcciones; track accion.id) {
                <div class="recorrido-item">
                  <div class="recorrido-icon">
                    @if(accion.fotoDe) {
                      <img class="avatar" src="data:image/jpg;base64,{{accion.fotoDe}}">
                    } @else {
                      <mat-icon>account_circle</mat-icon>
                    }
                  </div>
                  <div class="recorrido-content">
                    <div class="recorrido-accion">{{accion.accion}}</div>                                        
                    @if(accion.comentario) {
                      <span class="recorrido-accion">
                        <div class="recorrido-comentario">"{{accion.comentario}}"</div>
                      </span>
                  }
                    <div class="recorrido-info">                      
                      <span class="recorrido-usuario">{{accion.usuario}} / {{accion.departamentoDe}}</span>
                      <span class="recorrido-fecha">{{formatDate(accion.fechaHora)}}</span>
                    </div>
                  </div>
                </div>
              }
            </div>
          }@else {
            <p style="padding: 1rem;">No hay acciones registradas</p>
          }
        </div>

        <!-- Comentarios -->
        <div class="anexos-container">
          <h4 class="anexos-title">Comentarios</h4>
          @if(documentRouteComentarios.length > 0) {
            <div class="recorrido-list">
              @for (comentario of documentRouteComentarios; track comentario.id) {
                <div class="recorrido-item">
                  <div class="recorrido-icon">
                    @if(comentario.fotoDe) {
                      <img class="avatar" src="data:image/jpg;base64,{{comentario.fotoDe}}">
                    } @else {
                      <mat-icon>account_circle</mat-icon>
                    }
                  </div>
                  <div class="recorrido-content">
                    <div class="recorrido-comentario"><mat-icon class="material-symbols-outlined info-accion" matTooltip="{{comentario.accion}}">info</mat-icon> "{{comentario.comentario}}"</div>
                    <div class="recorrido-info">
                      <span class="recorrido-usuario">{{comentario.usuario}} / {{comentario.departamentoDe}}</span>
                      <span class="recorrido-fecha">{{formatDate(comentario.fechaHora)}}</span>
                    </div>
                  </div>
                </div>
              }
            </div>
          }@else {
            <p style="padding: 1rem;">No hay comentarios registrados</p>
          }
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Tareas">
      <ng-template mat-tab-label>
        <mat-icon class="material-symbols-outlined tab-icon">task</mat-icon>
        Tareas
      </ng-template>
      @if(loadingTareas){
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }@else{
      @if(documentoTareas && documentoTareas.length == 0){
      <p style="position: absolute; ">Documento sin tareas</p>
      }
      }
      <mat-toolbar style="background-color: transparent;"
        [style.position]="(documentoTareas && documentoTareas.length > 0)?'absolute':'unset'">
        <span class="sgd-spacer"> </span>
        <mat-checkbox (change)="mostrarTodo($event)">Mostrar todo</mat-checkbox>
      </mat-toolbar>
      <app-documento-tareas (successRefresh)="successRefreshHandler($event, 1)"
        (anexosRefresh)="anexosRefreshHandler($event)" [tareas]="documentoTareas" [tipoTarea]="tipoTarea"
        [hasParticipated]="hasParticipated" [isOwner]="isOwner"></app-documento-tareas>
    </mat-tab>
  </mat-tab-group>
} }
</div>